import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-compliances-covered',
  templateUrl: './compliances-covered.component.html',
  styleUrls: ['./compliances-covered.component.scss']
})
export class CompliancesCoveredComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
